export default "__VITE_ASSET__CKDZ8BpZ__"